// react core
import React from 'react';
import { NotificationManager } from 'react-notifications';

// components
import Reply from 'components/answers/reply';

// utils and api
import { clone_object } from 'commons/utils';
import { send_images } from 'commons/api';
import usePageTitle from 'commons/page_title';

// conf
import conf from 'conf/ajax';

export default function AskPanel(props)
{
    usePageTitle('Ask Question');
    const on_send = (obj) =>
    {
        let data_obj = clone_object(conf.ajax_configuration_object);
        // removing imageset from post data
        const image_set = clone_object(obj.image_set);
        const blob_set = clone_object(obj.blob_set);
        delete obj.image_set;
        delete obj.blob_set;
        const files_array = image_set.concat(blob_set);

        obj.tags = obj.tags.map(i=>i.id);
        data_obj.method = 'POST';
        data_obj.body = JSON.stringify(obj);
        fetch(conf.endpoints.insertpost, data_obj).then(function(response)
        {
            return response.json();
        })
        .then(function(data)
        {
            const last_cb = () =>
            {
                if(data.status === 'ok')
                {
                    NotificationManager.success('You will be redirected to the question page now', 'Question added!');
                    setTimeout(() =>
                    {
                        window.location.href = window.location.origin + conf.route.answers.replace(':id', data.id);
                    }, 3000);
                }
                else
                {
                    NotificationManager.error(data.message);
                }
            }
            if (data.status === 'ok' && data.id !== null)
            {
                if(files_array.length > 0)
                {
                    // reply created, sending pictures...
                    const post_image_url = `${data.id}`;
                    send_images(files_array, post_image_url).then(() =>
                    {
                        last_cb();
                    });
                }
                else
                {
                    // no images to send...
                    last_cb();
                }
            }
            else
            {
                NotificationManager.error('Error: unable to create content', 'Oops...', 5000, () => {});
            }
        }).catch(error =>
        {
            console.error('Error:', error);
            NotificationManager.error('Error: ' + error, 'Oops...', 5000, () => {});
        });
    };
    return (
        <>
            <div id="subheader">
                <div id="subheader-header">
                    <h2>Ask question</h2>
                </div>
                <div id="subheader-body">
                    <div id="subheader-body-askpage">
                    <p>Tips on writing a good question</p>
                    <ul>
                        <li><i className="fa-solid fa-1"></i><span>Make sure your question has not been asked already</span></li>
                        <li><i className="fa-solid fa-2"></i><span>Add the tags related to your question</span></li>
                        <li><i className="fa-solid fa-3"></i><span>Keep your question to the point</span></li>
                    </ul>
                    </div>
                </div>
            </div>

            <Reply type="question"
                   parent_type="folder"
                   pid={conf.server.main_folder.replaceAll('/', '')}
                   onSend={on_send}
                   show_title={true}
                   show_tags={true}
                   show_labels={true}
                   button_text="Ask question"
            />

        </>
    );
};
